import React, { useEffect, useState } from "react";
import { Menu, X, ArrowUpRight } from "lucide-react";
import Logo from "./Logo";

const links = [
  { label: "Studio", id: "studio" },
  { label: "Servizi", id: "servizi" },
  { label: "Recensioni", id: "recensioni" },
  { label: "Contatti", id: "contatti" },
];

const Navbar = () => {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const scrollTo = (id) => {
    setOpen(false);
    const el = document.getElementById(id);
    if (el) el.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <header
      className="fixed top-0 left-0 right-0 z-50 transition-all duration-500"
      style={{
        background: scrolled ? "rgba(10,10,10,0.82)" : "transparent",
        backdropFilter: scrolled ? "blur(14px)" : "none",
        borderBottom: scrolled ? "1px solid var(--onevo-line)" : "1px solid transparent",
      }}
    >
      <div className="max-w-[1400px] mx-auto px-6 md:px-10 h-[92px] flex items-center justify-between">
        <button onClick={() => scrollTo("top")} aria-label="ONEVO home">
          <Logo />
        </button>

        <nav className="hidden md:flex items-center gap-10">
          {links.map((l) => (
            <button
              key={l.id}
              onClick={() => scrollTo(l.id)}
              className="font-mono-label text-[11px] text-white/70 hover:text-white transition-colors duration-300"
            >
              {l.label}
            </button>
          ))}
        </nav>

        <button
          onClick={() => scrollTo("contatti")}
          className="hidden md:inline-flex items-center gap-2 bg-white text-black font-mono-label text-[11px] px-6 py-3.5 rounded-[3px] hover:bg-white/80 transition-colors duration-300"
        >
          Prenota Consulenza
        </button>

        <button
          className="md:hidden text-white"
          onClick={() => setOpen((v) => !v)}
          aria-label="menu"
        >
          {open ? <X size={26} /> : <Menu size={26} />}
        </button>
      </div>

      {open && (
        <div className="md:hidden bg-[#0a0a0a] border-t border-white/10 px-6 py-8 flex flex-col gap-6">
          {links.map((l) => (
            <button
              key={l.id}
              onClick={() => scrollTo(l.id)}
              className="font-display text-3xl text-white text-left"
            >
              {l.label}
            </button>
          ))}
          <button
            onClick={() => scrollTo("contatti")}
            className="inline-flex items-center justify-center gap-2 bg-white text-black font-mono-label text-[12px] px-6 py-4 rounded-[3px] mt-2"
          >
            Prenota Consulenza <ArrowUpRight size={16} />
          </button>
        </div>
      )}
    </header>
  );
};

export default Navbar;
